module.exports = __webpack_public_path__ + "static/img/clock.ed2dcdaa.png";